import { useState, useCallback } from "react";
import { getUserRequest } from "./../../home/network/getUserRequest";
import { getUserDataRequest } from "./../../home/network/getUserDataRequest";

export const useGetUserData = () => {
  const [loading, setLoading] = useState<boolean>(false);

  const getUser = useCallback(async (id) => {
    setLoading(true);
    const res = await getUserRequest(id);
    setLoading(false);
    return res.data;
  }, []);

  const getUserData = useCallback(async (id) => {
    setLoading(true);
    const res = await getUserDataRequest(id);
    setLoading(false);
    return res.data;
  }, []);

  return { loading, getUserData, getUser };
};
